import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
export default class SchedulePollModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "datetime", void 0);
    _defineProperty(this, "error", null);
  }
  oninit(vnode) {
    super.oninit(vnode);

    // Prefill the picker when reopening for an already-scheduled draft.
    // The model returns UTC; <input type="datetime-local"> wants the
    // local-zone equivalent in YYYY-MM-DDTHH:mm format.
    const scheduled = this.attrs.poll.scheduledPublishAt();
    this.datetime = Stream(scheduled ? dayjs(scheduled).local().format('YYYY-MM-DDTHH:mm') : '');
  }
  className() {
    return 'SchedulePollModal Modal--small';
  }
  title() {
    const isEditing = !!this.attrs.poll.scheduledPublishAt();
    return app.translator.trans(isEditing ? 'fof-polls.forum.compose.schedule_publication_edit' : 'fof-polls.forum.compose.schedule_publication');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, app.translator.trans('fof-polls.forum.compose.schedule_datetime_label')), m("input", {
      type: "datetime-local",
      className: "FormControl",
      bidi: this.datetime
    })), this.error && m("div", {
      className: "Form-group helpText text-error"
    }, this.error), m("div", {
      className: "Form-group"
    }, m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.loading
    }, app.translator.trans('fof-polls.forum.compose.schedule_submit'))));
  }
  async onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.error = null;
    try {
      var _this$attrs$onSuccess, _this$attrs;
      // When invoked from a compose form, persist the user's current edits
      // as a draft first. If validation fails, PollForm.submit shows an
      // alert and returns false — we must NOT fall through to publish,
      // otherwise we'd schedule against stale DB state while the on-screen
      // form is invalid. When invoked from the controls menu there's no
      // form (poll already persisted), so we skip straight to scheduling.
      if (this.attrs.form) {
        const ok = await this.attrs.form.submit({
          isDraft: true
        });
        if (!ok) {
          return;
        }
      }
      const poll = this.attrs.form ? this.attrs.form.state.poll : this.attrs.poll;
      if (!poll.id()) {
        throw new Error('Cannot schedule an unsaved poll.');
      }
      await poll.publish({
        scheduledFor: new Date(this.datetime()).toISOString()
      });
      this.hide();
      (_this$attrs$onSuccess = (_this$attrs = this.attrs).onSuccess) == null || _this$attrs$onSuccess.call(_this$attrs, poll);
    } catch (e) {
      var _ref, _e$response$errors$0$, _e$response;
      this.error = (_ref = (_e$response$errors$0$ = e == null || (_e$response = e.response) == null || (_e$response = _e$response.errors) == null || (_e$response = _e$response[0]) == null ? void 0 : _e$response.detail) != null ? _e$response$errors$0$ : e.message) != null ? _ref : 'Unknown error';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('fof-polls', 'forum/components/SchedulePollModal', SchedulePollModal);